/**
 * @fileoverview Agent definition for world-organization-details-generator-v3.
 *
 * This agent generates complete details for a world organization based on a
 * selected creative direction from the details ideation agent.
 *
 * @category world-building.organizations.details
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-organization-details-generator-v3',
  kind: 'primitive',
  name: 'World Organization Details Generator',
  description: 'Generates complete details for a world organization based on a selected creative direction.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.organizations.details',
    usedBy: ['use-world-organization-details-generator-v3.ts'],
    usedInComposites: [],
    relatedAgents: [
      'world-organization-details-ideation-v3',
      'world-organization-snapshotter-v3',
    ],
  },
};
